import { useEffect, useState } from "react";
import { Image as ImageAntd, Spin } from "antd";
import { LocalStorageKey } from "../../../constants/localStorageKeys";
import ImageDefault from "../../../assets/svg/item-iamge-default.png";

import { fetchImageBlob } from '../../../utils/imageRequest'
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import LoadingGlobalComp from "../../Commons/Loading";

// Module-level caches so a thumbnail is fetched only once per URL — even if the
// card unmounts/remounts (e.g. collapsing & re-opening a Section).
// - blobUrlCache: url -> object URL of the already-downloaded blob
// - inFlightCache: url -> in-flight request, to de-dupe concurrent mounts
const blobUrlCache = new Map<string, string>();
const inFlightCache = new Map<string, Promise<string>>();

const fetchThumbnail = (url: string): Promise<string> =>
{
      const cached = blobUrlCache.get(url);
      if (cached) return Promise.resolve(cached);

      const existing = inFlightCache.get(url);
      if (existing) return existing;

      const request = fetchImageBlob(url)
            .then((res) =>
            {
                  if (res.status !== 200) throw new Error("Thumbnail request failed");
                  const objectUrl = URL.createObjectURL(res.data);
                  blobUrlCache.set(url, objectUrl);
                  return objectUrl;
            })
            .finally(() =>
            {
                  // Allow a retry later if the request failed.
                  inFlightCache.delete(url);
            });

      inFlightCache.set(url, request);
      return request;
};

const Thumbnail = ({ url, token }: { url: any; token: string }) =>
{
      const [imgSrc, setImgSrc] = useState<string>();

      const staticConfig = localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? '';

      const parsedConfig = JSON.parse(staticConfig);
      const authMethod = parsedConfig.REACT_APP_AUTHENTICATION_METHOD;




      let searchState = useSelector((state: RootState) => state.search);
      let providerId = useSelector(
            (state: RootState) => state.mapTasking.providerId
      );
      // @ts-ignore
      let loading = searchState[`loading_provider_${providerId}`];

      useEffect(() =>
      {
            if (authMethod === "COOKIES") return;

            if (!url)
            {
                  setImgSrc(ImageDefault);
                  return;
            }

            // Cache hit → reuse the already-downloaded blob, no new API call.
            const cached = blobUrlCache.get(url);
            if (cached)
            {
                  setImgSrc(cached);
                  return;
            }

            let active = true;
            setImgSrc(ImageDefault);

            fetchThumbnail(url)
                  .then((objectUrl) =>
                  {
                        if (active) setImgSrc(objectUrl);
                  })
                  .catch(() =>
                  {
                        if (active) setImgSrc(ImageDefault);
                  });

            return () =>
            {
                  active = false;
            };

      }, [url, token, authMethod]);

      return authMethod !== "COOKIES" ? (

            <ImageAntd
                  src={imgSrc}
                  alt="thumbnail"
                  className="h-full"
                  // placeholder={
                  //       <ImageAntd
                  //             className="rounded-sm !w-[42px] !h-[42px]"
                  //             preview={false}
                  //             src={ImageDefault}
                  //       />
                  // }
                  placeholder={
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                              {/* <Spin size="large" /> */}
                              <LoadingGlobalComp size={28} />
                        </div>
                  }
                  preview={false}
                  fallback={ImageDefault}
            />
      ) : (
            <ImageAntd
                  loading="lazy"
                  // width={42}
                  className="h-full"
                  src={
                        url || ImageDefault
                  }
                  alt="img item"
                  onError={(e: any) =>
                  {
                        e.target.src = ImageDefault;
                  }}
                  // placeholder={
                  //       <ImageAntd
                  //             className="rounded-sm img-card-item-catalog-search-drawer !min-w-[42px] !h-[42px] !w-[42px] !max-h-[42px] !max-w-[42px]"
                  //             preview={false}
                  //             src={ImageDefault}
                  //             width={42}
                  //       />
                  // }
                  placeholder={
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                              {/* <Spin size="large" /> */}

                              <LoadingGlobalComp size={28} />
                        </div>
                  }
                  preview={false}

                  fallback={ImageDefault}
            />
      );
};

export default Thumbnail
